import { Injectable }                   from "@angular/core";
import { 
    Router, 
    CanActivate, 
    ActivatedRouteSnapshot, 
    RouterStateSnapshot 
}                                       from "@angular/router";
import { 
    Http, 
    Headers, 
    RequestOptions, 
    Response 
}                                       from "@angular/http";
import { Observable }                   from 'rxjs';

import {
    USER_LOCAL_STORAGE
}                                       from "../common.constant";
import { 
    CONSTANT
}                                       from "../../_custom";

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private http: Http,
        private router: Router
    ) {         
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        let usr;
        let loc = localStorage.getItem(USER_LOCAL_STORAGE);
        if (loc != undefined) {
            usr = JSON.parse(loc);
        }

        let data = "false";
        if (usr == undefined) {
            data = "true";
        }
        
        let headers = new Headers({
            "Content-Type": "application/json; charset=UTF-8"
        });
		let options = new RequestOptions({
			"headers": headers
		});
        return this.http.post(CONSTANT.SERVER_PATH + "api/Common/IsAuthenticated", data, options)
            .toPromise()
            .then((res: Response) => {
                let body = res.json();
                if (body.Data == undefined) {
                    this.router.navigate(["/login"],
                    {
                        queryParams: { returnUrl: state.url }
                    });

                    return false;
                }
                else if (usr == undefined) {
                    localStorage.removeItem(USER_LOCAL_STORAGE);
                    localStorage.setItem(USER_LOCAL_STORAGE, JSON.stringify({
                        userName: body.Data["UserName"],
                        displayName: body.Data["DisplayName"],
                        groupID:  body.Data["GroupID"]
                    }));
                }

                return true;
            })
            .catch((error: Response) => {
                if (error != undefined) {
                    if (error.status == 0) {
                        this.router.navigate(["/503"]);
                        return false;
                    }
                }
                
                this.router.navigate(["/login"],
                    {
                        queryParams: { returnUrl: state.url }
                    });
            });
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/guards/auth.guard.ts